import { render, staticRenderFns } from "./OverdueInvoicesModal.vue?vue&type=template&id=be08ac30&scoped=true"
import script from "./OverdueInvoicesModal.vue?vue&type=script&lang=js"
export * from "./OverdueInvoicesModal.vue?vue&type=script&lang=js"
import style0 from "./OverdueInvoicesModal.vue?vue&type=style&index=0&id=be08ac30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be08ac30",
  null
  
)

export default component.exports